import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 text-gray-800 text-sm leading-relaxed">
      <h1 className="text-2xl font-semibold mb-2">Privacy Policy</h1>
      <p className="text-xs text-gray-500 mb-6">
        Effective Date: 18-05-2025| Last Updated: 18-05-2025
      </p>

      <p className="mb-4">
        Thank you for using our VFC Management Website and Mobile Applications
        ("Service"). This Privacy Policy explains how we collect, use, and
        protect your information, operated by Thrayam Solutions Private Limited.
      </p>

      <h4 className="text-base font-medium mt-6 mb-2">
        1. Information We Collect
      </h4>
      <p className="mb-2">
        We do <strong>not</strong> collect usage data, cookies, or tracking
        information. We only collect information you voluntarily provide:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>
          <strong>Personal Information:</strong> Name, contact details, address,
          and photos for VFC-related records.
        </li>
      </ul>

      <h4 className="text-base font-medium mt-6 mb-2">
        2. How We Use Your Information
      </h4>
      <ul className="list-disc list-inside mb-4">
        <li>Maintain VFC records</li>
        <li>Authenticate users and ensure secure access</li>
        <li>Support user inquiries</li>
        <li>Send important updates (if needed)</li>
      </ul>

      <h4 className="text-base font-medium mt-6 mb-2">3. Data Retention</h4>
      <p className="mb-4">
        We retain data only as long as required for service or legal reasons.
      </p>

      <h4 className="text-base font-medium mt-6 mb-2">4. Data Security</h4>
      <p className="mb-4">
        We follow security best practices including encryption and controlled
        access.
      </p>

      <h4 className="text-base font-medium mt-6 mb-2">5. Your Rights</h4>
      <p className="mb-4">
        You can request access, updates, or deletion of your data. Contact us
        via the details below.
      </p>

      <h4 className="text-base font-medium mt-6 mb-2">6. Children’s Privacy</h4>
      <p className="mb-4">
        Our service is not intended for individuals under 18 years of age.
      </p>

      <h4 className="text-base font-medium mt-6 mb-2">
        7. Changes to This Policy
      </h4>
      <p className="mb-4">
        We may update this policy from time to time. Revisions will appear here
        with the updated date.
      </p>

      <h4 className="text-base font-medium mt-6 mb-2">8. Contact Us</h4>
      <p className="mb-1">Thrayam Solutions Private Limited</p>
      <p className="mb-1">Edavattam,ThirunanthiKari,Kulasekharam,Kanyakumari</p>
      <p className="mb-1">8807259471</p>
      <p className="mb-1">thrayamtechsolutions@gmail.com</p>
    </div>
  );
};

export default PrivacyPolicy;
